import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Checkbox from '../../../Checkbox/Checkbox';

export class CustomMultiselect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: [],
      all: false,
    };
  }

  static defaultProps = {
    items: [],
  };

  componentDidMount() {
    this.setState({
      values: this.props.selectedItems || [],
    });
    this.checkIfAllSelected(this.props.selectedItems);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedItems != this.props.selectedItems) {
      this.setState({
        values: this.props.selectedItems || [],
      });
      this.checkIfAllSelected(this.props.selectedItems);
    }
  }

  checkIfAllSelected = (values) => {
    const all =
      !!this.props.items &&
      _.every(this.props.items, (v) => {
        const i = _.indexOf(values, v.value);
        return v.hidden || i > -1;
      });
    this.setState({ all });
  };

  handleColorChange = (e) => {
    if (typeof this.props.onColorChange === 'function') {
      this.props.onColorChange(e);
    }
  };

  handleChange = (e) => {
    let values = [...this.state.values];

    if (e.name === 'select_all') {
      if (!e.checked) {
        values = _(this.props.items)
          .filter((i) => i.hidden)
          .map((i) => i.value)
          .value();
      } else {
        values = _.map(this.props.items, (i) => i.value);
      }
    } else {
      if (!e.checked) {
        let index = values.indexOf(e.value);
        if (index === -1) {
          index = _.findIndex(values, { _id: e.value._id });
        }

        values.splice(index, 1);
      } else {
        values.push(e.value);
      }

      values = _.uniq(values);
    }

    this.setState({ values });
    this.props.onSelect(values, this.props.name);
  };

  render() {
    const { name, items, fieldId, colorsChangable, itemRenderer } = this.props;
    const { values, all } = this.state;

    return (
      <div>
        <Checkbox
          className="select_all"
          name="select_all"
          id="select_all"
          label="Select all"
          value="select_all"
          checked={all}
          onChange={this.handleChange}
        />
        {items.filter((item) => !item.hidden).map((item, i) => {
          return (
            <Checkbox
              name={name}
              id={i}
              key={i}
              label={item.label}
              value={item.value}
              checked={values.indexOf(item.value) > -1 || _.findIndex(values, { _id: item.value._id }) > -1}
              fieldId={fieldId}
              colorsChangable={colorsChangable}
              ItemRenderer={itemRenderer}
              rendererValues={item}
              onChange={this.handleChange}
              onColorChange={this.handleColorChange}
            />
          );
        })}
      </div>
    );
  }
}

CustomMultiselect.propTypes = {
  name: PropTypes.string.isRequired,
  items: PropTypes.array,
  selectedItems: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
  itemRenderer: PropTypes.func,
  fieldId: PropTypes.string,
  colorsChangable: PropTypes.bool,
  onColorChange: PropTypes.func,
};
